import React from "react";

const marineHullInsuranceSyllabus = [
    {
        chapter: 1,
        title: "Introduction of Marine Hull Insurance",
        subTopics: [
            "Types of Vessels",
            "Vessel Classification",
            "Liner & Tramp vessels",
        ],
        hours: 2,
    },
    {
        chapter: 2,
        title: "Marine Hull - Types of Policies, Covers & Clauses",
        subTopics: [
            "ITC Clauses",
            "Warranties",
            "Exclusions",
        ],
        hours: 2,
    },
    {
        chapter: 3,
        title: "Ship Builders’ Risks Insurance",
        subTopics: [
            "Institute Clauses for Builder’s Risks",
            "Exclusions",
        ],
        hours: 2,
    },
    {
        chapter: 4,
        title: "Marine Hull Underwriting & Rating",
        subTopics: [
            "Proposal Form",
            "TL & OTL Rating",
        ],
        hours: 2,
    },
    {
        chapter: 5,
        title: "Ship Classification Societies",
        subTopics: [
            "Classification Certificate",
            "Role of Classification societies",
        ],
        hours: 1,
    },
    {
        chapter: 6,
        title: "Special Insurances",
        subTopics: [
            "Ship Repairs Liability Insurance",
            "Charterer’s Liability Insurance",
            "Mortgagee’s Interest Insurance",
            "Insurance of Port Liabilities",
        ],
        hours: 3,
    },
    {
        chapter: 7,
        title: "Insurance of Oil & Gas, SBM",
        subTopics: [
            "Oil & Gas wells",
            "Risk in SBM Operation",
        ],
        hours: 2,
    },
    {
        chapter: 8,
        title: "War & Strikes Risks Insurances",
        subTopics: [
            "Scope of cover",
            "Exclusions",
            "Termination",
        ],
        hours: 2,
    },
    {
        chapter: 9,
        title: "P & I Clubs, Marine Hull Reinsurance",
        subTopics: [
            "P & I Mutual Clubs",
            "Fix Premium Clubs",
            "Hull Reinsurance",
        ],
        hours: 2,
    },
    {
        chapter: 10,
        title: "Marine Hull Claims",
        subTopics: [
            "Type of losses",
            "Particular Average",
            "Subrogation & Notice of Abandonment",
            "Particular charges",
            "Claim on Hull Policies",
        ],
        hours: 3,
    },
    {
        chapter: 11,
        title: "General Average & Salvage Claims",
        subTopics: [
            "Aspects of GA",
            "GA & Insurance",
            "GA Security and Bond",
            "GA Disbursement Insurance",
        ],
        hours: 2,
    },
    {
        chapter: 12,
        title: "Collision Liabilities & Insurance of Freight - Claims",
        subTopics: [
            "Collision Liabilities",
            "Collision liability claims on H & M Policy",
            "Freight Claims",
        ],
        hours: 2,
    },
];

export const MarineHullInsuranceUnderwritingandClaimsTable = () => {
    const totalHours = marineHullInsuranceSyllabus.reduce((sum, item) => sum + item.hours, 0);

    return (
        <div className="container my-3 px-0"
            style={{
                maxHeight: 'fit-content'
            }}
        >
            <h5 className="text-center">IC-70- MARINE HULL INSURANCE UNDERWRITING AND CLAIMS
            </h5>
            <div className="table-responsive"
                style={{ height: '70vh' }}
            >
                <table className="table table-bordered table-striped align-middle">
                    <thead className="table-success text-center">
                        <tr>
                            <th className="bgblue">Chapter</th>
                            <th className="bgblue">Title</th>
                            <th className="bgblue">Sub-Topics</th>
                            <th className="bgblue">Training Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        {marineHullInsuranceSyllabus.map((item, index) => (
                            <tr key={index}>
                                <td className="text-center fw-bold">{item.chapter}</td>
                                <td>{item.title}</td>
                                <td>
                                    <ul className="mb-0 ps-3" style={{ listStylePosition: "inside" }}>
                                        {item.subTopics.map((topic, i) => (
                                            <li key={i}>{topic}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="text-center fw-semibold">{item.hours}</td>
                            </tr>
                        ))}
                        <tr className="table-secondary fw-bold">
                            <td colSpan={3} className="text-end">Total Training Hours =</td>
                            <td className="text-center">{totalHours}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
